<template>
<v-dialog v-model="display" width="400" persistent>
    <v-card v-if="$store.getters.branch">
        <v-img
        :src="treeImage"
        height="200px"
        ></v-img>

        <v-card-title>
            <v-spacer/>
                <div>
                    <h5 align='center'>CURRENT BRANCH</h5> 
                    <h2 align='center'>{{$store.getters.branch}}</h2>
                </div>
            <v-spacer/>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer/>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            text
            @click="display = false"
            nw-data="BranchTracker dismiss"
          >
            OK
          </v-btn>
        </v-card-actions>  
    </v-card>  
</v-dialog>
</template>

<script>
import treeImage from './tree.jpg';

export default {
    name: "BranchTracker",
    data: function(){
        return {
            display: false
        }
    },
    methods: {
        init: function(){
            var self = this;
            if(process.env.NODE_ENV=='development'){
                self.display = true;
                setTimeout(function(){
                    self.display = false;
                },3000)
            }
            var action = 'branch_tracker';
            var call = 'track_branch';
            self.$sendBackgroundRequest({
                action: action,
                call: call,
                branch: self.$store.getters.branch
            })
        }
    },
    computed: {
        csrf: function(){
            return this.$store.getters.csrf;
        },
        treeImage: function(){
            return treeImage;
        }
    },
    watch: {
        csrf: function(){
            var self = this;
            if(self.csrf){
                self.init();
            }
        }
    }
}
</script>

<style>

</style>